import { DATE_FORMAT } from "@/constants/default"
import { AuditLog } from "@/types/auditlog.type"
import { formatDateTimeAutoToString } from "@/utils/format"
import { ColumnDef } from "@tanstack/react-table"
import { useTranslation } from "react-i18next"

export default function TableHeader(): ColumnDef<AuditLog>[] {
    const {t} = useTranslation()

    return [
        {
            header: t("table.email"),
            accessorKey: "email",
            enableSorting: false
        },
        {
            header: t("table.type"),
            accessorKey: "type",
            enableSorting: false
        },
        {
            header: t("auditlog.old_data"),
            accessorKey: "old_data",
            enableSorting: false,
            cell: ({row}) => {
                return row.original.old_data ? <textarea className="resize text-sm p-2 w-60 ring-1 ring-slate-900/10 shadow-sm rounded-md dark:bg-slate-800 dark:ring-0 dark:highlight-white/5" defaultValue={row.original.old_data || ""}></textarea> : <>N/A</>
            }
        },
        {
            header: t("auditlog.new_data"),
            accessorKey: "new_data",
            enableSorting: false,
            cell: ({row}) => {
                return row.original.new_data ? <textarea className="resize text-sm p-2 w-60 ring-1 ring-slate-900/10 shadow-sm rounded-md dark:bg-slate-800 dark:ring-0 dark:highlight-white/5" defaultValue={row.original.new_data || ""}></textarea> : <>N/A</>
            }
        },
        {
            header: t("table.action"),
            accessorKey: "action",
            enableSorting: false
        },
        {
            header: t("table.created_at"),
            accessorKey: "created_at",
            cell: ({ row }) => formatDateTimeAutoToString(row.original.created_at, DATE_FORMAT)
        },
    ]
}